import React from 'react';

const CompetitorsTab = ({ analysis, clientDomain }) => {
    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Analisi Competitor Organici</h2>

            {analysis.organicDomains.length > 0 ? (
                <>
                    <div className="mb-4 p-3 bg-blue-50 rounded">
                        <p className="text-sm">
                            <strong>Domini organici trovati:</strong> {analysis.organicDomains.length} |
                            <strong className="ml-2">Con multi-presenza:</strong> {analysis.organicDomains.filter(d => d.multiPresence).length}
                        </p>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="text-left p-3 font-semibold">Pos</th>
                                    <th className="text-left p-3 font-semibold">Dominio</th>
                                    <th className="text-left p-3 font-semibold">Titolo</th>
                                    <th className="text-center p-3 font-semibold">Multi-presenza</th>
                                </tr>
                            </thead>
                            <tbody>
                                {analysis.organicDomains.map((item, i) => {
                                    const isClient = clientDomain && item.domain.toLowerCase().includes(clientDomain.toLowerCase());
                                    return (
                                        <tr key={i} className={`border-b ${isClient ? 'bg-purple-50' : i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                                            <td className="p-3">
                                                <span className={`font-bold ${item.position <= 3 ? 'text-green-600' :
                                                    item.position <= 7 ? 'text-blue-600' :
                                                        'text-gray-600'
                                                    }`}>
                                                    #{item.position}
                                                </span>
                                            </td>
                                            <td className="p-3">
                                                <div className="flex items-center gap-2">
                                                    <span className={`font-medium ${isClient ? 'text-purple-700 font-bold' : 'text-blue-600'}`}>
                                                        {item.domain}
                                                    </span>
                                                    {isClient && (
                                                        <span className="bg-purple-600 text-white text-xs px-2 py-0.5 rounded-full">
                                                            TUO CLIENTE
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="p-3">
                                                <div className="text-gray-700 max-w-md truncate">{item.title}</div>
                                            </td>
                                            <td className="p-3 text-center">
                                                {item.multiPresence ? (
                                                    <div className="flex flex-col items-center gap-1">
                                                        <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-semibold">
                                                            Multi-presenza
                                                        </span>
                                                        <div className="text-xs text-gray-600">
                                                            {item.inShopping && '🛒 Shopping'}
                                                            {item.inVideo && '🎥 Video'}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="text-gray-400">-</span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-green-50 p-4 rounded-lg">
                            <h3 className="font-semibold mb-2 text-green-800">Top 3 Posizioni</h3>
                            <ul className="text-sm space-y-1">
                                {analysis.organicDomains.slice(0, 3).map((d, i) => (
                                    <li key={i}>#{d.position} - {d.domain}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="bg-purple-50 p-4 rounded-lg">
                            <h3 className="font-semibold mb-2 text-purple-800">Domini con Vantaggio Competitivo</h3>
                            <p className="text-sm">
                                {analysis.organicDomains.filter(d => d.multiPresence).length > 0 ? (
                                    <>
                                        {analysis.organicDomains.filter(d => d.multiPresence).map(d => d.domain).join(', ')}
                                        <span className="block mt-1 text-xs">Presenti sia in organico che in altre features</span>
                                    </>
                                ) : (
                                    'Nessun dominio con presenza multipla'
                                )}
                            </p>
                        </div>
                    </div>
                </>
            ) : (
                <p className="text-gray-500 text-center py-8">Nessun risultato organico trovato</p>
            )}
        </div>
    );
};

export default CompetitorsTab;
